import { Component, OnInit } from '@angular/core';
import { GlobalFunctionsGui } from 'globales-projekt-angular';
import { Preisstand } from 'src/app/data/ws/dbKlassen/preisstand.model';
import { LocalService } from 'src/app/services/local.service';

@Component({
  selector: 'app-begriffserlaeuterungen-baukost',
  templateUrl: './begriffserlaeuterungen-baukost.component.html',
  styleUrls: ['./begriffserlaeuterungen-baukost.component.css']
})
export class BegriffserlaeuterungenBaukostComponent implements OnInit {

  preisstandDataSource!: Preisstand[];

  preisstandDisplayedCols: string[] = ['jahr', 'wert'];


  gliederungsebeneDataSource = [
    { kostengruppe: '100', bezeichnung: 'Grundstück' },
    { kostengruppe: '200', bezeichnung: 'Vorbereitende Maßnahmen' },
    { kostengruppe: '300', bezeichnung: 'Bauwerk – Baukonstruktionen' },
    { kostengruppe: '400', bezeichnung: 'Bauwerk – Technische Anlagen' },
    { kostengruppe: '500', bezeichnung: 'Außenanlagen und Freiflächen' },
    { kostengruppe: '600', bezeichnung: 'Ausstattung und Kunstwerke' },
    { kostengruppe: '700', bezeichnung: 'Baunebenkosten' },
    { kostengruppe: '800', bezeichnung: 'Finanzierung' },


  ];

  gliederungsebeneDisplayedCols: string[] = ['kostengruppe', 'bezeichnung'];



  kostengruppeDataSource = [
    { kostengruppe: '310', bezeichnung: 'Baugrube / Erdbau' },
    { kostengruppe: '320', bezeichnung: 'Gründung / Unterbau' },
    { kostengruppe: '330', bezeichnung: 'Außenwände' },
    { kostengruppe: '340', bezeichnung: 'Innenwände' },
    { kostengruppe: '350', bezeichnung: 'Decken' },
    { kostengruppe: '360', bezeichnung: 'Dächer' },
    { kostengruppe: '370', bezeichnung: 'Infrastrukturanlagen' },
    { kostengruppe: '380', bezeichnung: 'Baukonstruktive Einbauten' },
    { kostengruppe: '390', bezeichnung: 'Sonstige Baukonstruktionen' },
    { kostengruppe: '410', bezeichnung: 'Abwasser-, Wasser-, Gasanlagen' },
    { kostengruppe: '420', bezeichnung: 'Wärmeversorgung' },
    { kostengruppe: '430', bezeichnung: 'Raumlufttechnik' },
    { kostengruppe: '440', bezeichnung: 'Elektrische Anlagen' },
    { kostengruppe: '450', bezeichnung: 'Kommunikations- und Sicherheitstechnik' },
    { kostengruppe: '460', bezeichnung: 'Förderanlagen' },
    { kostengruppe: '470', bezeichnung: 'Nutzungsspezifische Anlagen' },
    { kostengruppe: '480', bezeichnung: 'Gebäudeautomation' },
    { kostengruppe: '490', bezeichnung: 'Sonstige technische Anlagen' },
    { kostengruppe: '520', bezeichnung: 'Gründung / Unterbau (Außenanlagen)' },
    { kostengruppe: '530', bezeichnung: 'Oberbau / Deckschichten' },
    { kostengruppe: '540', bezeichnung: 'Baukonstruktionen in Außenanlagen' },
    { kostengruppe: '550', bezeichnung: 'Technische Anlagen in Außenanlagen' },
    { kostengruppe: '560', bezeichnung: 'Einbauten in Außenanlagen' },
    { kostengruppe: '570', bezeichnung: 'Vegetationsflächen' },
    { kostengruppe: '580', bezeichnung: 'Wasserflächen' },
    { kostengruppe: '590', bezeichnung: 'Sonstige Außenanlagen' },
  ];

  kostengruppeDisplayedCols: string[] = ['kostengruppe', 'bezeichnung'];

  flaecheDataSource = [
    {flaeche: 'Tierproduktgewinnung netto', beschreibung: 'Flächen zur Gewinnung und Lagerung von Tierprodukten (z. B. Melkstand inklusive Wartehof, Milchlager)'},
    {flaeche: 'Tier netto', beschreibung: 'vom Tier nutzbare Flächen für Aktivitäten und zum Liegen'},
    {flaeche: 'Fütterung netto', beschreibung: 'Flächen für Lagerung, Aufbereitung und Vorlage von Futter'},
    {flaeche: 'Bewirtschaftung netto', beschreibung: 'Flächen für Arbeitskräfte, Technik und Betriebsabläufe'}
  ];
   
  flaecheDisplayedCols: string[] = ['flaeche', 'beschreibung'];

  kostenblockDataSource = [
    { kostenblock: 'Tier', beschreibung: 'Investitionsbedarf für Baukonstruktionen und technische Anlagen, die denjenigen Funktionsbereichen zugeordnet sind, die die Tiere nutzen können.' },
    { kostenblock: 'Tierproduktgewinnung', beschreibung: 'Investitionsbedarf für Baukonstruktionen und technische Anlagen, die denjenigen Funktionsbereichen zugeordnet sind, die zur Entnahme, Lagerung und Behandlung von Tierprodukten (Milch, Eiern) dienen.' },
    { kostenblock: 'Fütterung', beschreibung: 'Investitionsbedarf für Baukonstruktionen und technische Anlagen, die denjenigen Funktionsbereichen zugeordnet sind, die für Futterlager, Futteraufbereitung und Futtervorlage dienen.' },
    { kostenblock: 'Bewirtschaftung', beschreibung: 'Investitionsbedarf für Baukonstruktionen und technische Anlagen, die denjenigen Funktionsbereichen zugeordnet sind, die überwiegend vom Menschen genutzt werden.' }
  ];

 kostenblockDisplayedCols: string[] = ['kostenblock', 'beschreibung'];

  constructor(public localService: LocalService) {
    this.preisstandDataSource = [...this.localService.preisstandList.value]
      .sort((a, b) => a.preisstand - b.preisstand);

  }

  ngOnInit(): void {
  }

  onClickUp() {
    GlobalFunctionsGui.clickUp();
  }

  onClickDown() {
    GlobalFunctionsGui.clickDown();
  }


}
